import React from 'react';
import classNames from 'classnames';
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import PropsTypes from 'prop-types';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import { ChevronDown, MoreHorizontal } from 'react-feather';
import styled from '@emotion/styled';

const ButtonDropdownCustom = (props) => {
  //Color Theme
  const themeStatus = useSelector(getThemeColor);
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-toggle-color {
      display: inline-block;
      font-weight: 500;
      color: ${colorTextStatus};
      text-align: center;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
      background-color: ${colorStatus};
      border: 1px solid transparent;
      padding: 0.786rem 0.5rem;
      font-size: 16px;
      line-height: 1;
      border-radius: 0px 23px 23px 0px;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      -webkit-transition: color 0.15s ease-in-out,
        background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out, background 0s, border 0s;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
        background 0s, border 0s;
    }

    .btn-toggle-color:disabled {
      opacity: 0.65;
    }
    .btn-toggle-color:hover {
      background-color: #ffffff;
      color: ${colorStatus};
      border-color: ${colorStatus};
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
      color: ${themeStatus} !important;
      text-decoration: none;
    }
    .content-page-name:hover {
      color: ${themeStatus} !important;
    }
  `;

  return (
    <UncontrolledButtonDropdown direction="down" group className="savebtn">
      <button
        // color={props.color || 'danger'}
        onClick={props.action}
        className={classNames(
          'btn-group-color button-notpass-question pl-1 pr-05',
          props.classNameBtn,
        )}
        disabled={props.disabled || props.disabledBtn}
        style={{
          backgroundColor: `${colorStatus}`,
          color: `${colorTextStatus}`,
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'white';
          e.target.style.borderColor = colorStatus;
          e.target.style.color = colorStatus;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = colorStatus;
          e.target.style.color = colorTextStatus;
        }}
      >
        {props.iconLeft}
        {props.title}
        {props.iconRight}
      </button>
      <Stylescal>
        <DropdownToggle
          className="btn-toggle-color dropdown-toggle-split px-05"
          // color={props.color || 'danger'}
          color="transparent"
          // caret
          disabled={props.disabled || props.disabledMenu}
        >
          <ChevronDown height={16} width={16} />
        </DropdownToggle>

        <DropdownMenu className="drop-down-list-item">
          {props.actions?.map((item, index) => (
            <DropdownItem
              key={index}
              onClick={item?.action}
              className="create-que-font mb-50"
            >
              {item.iconLeft}
              <span className="align-middle content-page-name">
                {item.text}
              </span>
              {item.iconRight}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Stylescal>
    </UncontrolledButtonDropdown>
  );
};

ButtonDropdownCustom.propTypes = {
  actions: PropsTypes.array,
  color: PropsTypes.string,
  disabled: PropsTypes.bool,
  disabledBtn: PropsTypes.bool,
  disabledMenu: PropsTypes.bool,
  title: PropsTypes.string,
  iconLeft: PropsTypes.any,
  iconRight: PropsTypes.any,
  action: PropsTypes.func,
  classNameBtn: PropsTypes.any,
};

export default ButtonDropdownCustom;
